<template>
  <div class="body">
    <div class="chat-body">
      <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          direction="up"
          :immediate-check="false"
          offset="0"
      >
        <div v-for="(item,index) of list" :key="index">
          <div v-if="item.senderRole == 'clerk'" class="my-box">
            <div v-if="index == 0 || formatDate(item.createTime) != formatDate(list[index - 1].createTime)" class="date">{{formatDate(item.createTime)}}</div>
            <div class="my">
              <div class="bubble">{{item.message}}</div>
            </div>
          </div>

          <div v-if="item.senderRole == 'user'" class="you-box">
            <div v-if="index == 0 || formatDate(item.createTime) != formatDate(list[index - 1].createTime)" class="date">{{formatDate(item.createTime)}}</div>
            <div class="you">
              <div class="head">
                <img v-if="userData.headImgUrl" :src="userData.headImgUrl">
              </div>
              <div class="bubble-box">
                <div class="bubble">{{item.message}}</div>
                <div class="state">{{item.isRead ? '已读' : '未读'}}</div>
              </div>
            </div>
          </div>
        </div>

        <div slot="loading"></div>
        <div slot="finished"></div>
        <div slot="error"></div>
      </van-list>
    </div>
    <div class="input-box">
      <van-field v-model="value" />
      <div class="sending" :class="!buttomType ? 'sendingNo' : ''" @click="sending">发送</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Field,
  Button,
  List,
  Cell,
  CellGroup,
  Tag,
  Icon,
  ActionSheet,
  Dialog,
  Tab,
  Tabs, Popup, Toast, Picker
} from 'vant';
import {sendMessage,bothPersonalInfo,read} from '@/api/clerk/private_message_record'
import moment from "moment";
import {getPrivateMessageRecord} from "../api/clerk/private_message_record";


Vue.use(Button)
    .use(List)
    .use(Cell)
    .use(CellGroup)
    .use(Tag)
    .use(Icon)
    .use(ActionSheet)
    .use(Dialog)
    .use(Tab)
    .use(Tabs)
    .use(Popup)
    .use(Picker)
    .use(Field)


export default {
  name: 'chat',
  components: {

  },
  data() {
    return {
      id: this.$route.params.id,
      userData: null,
      buttomType: false,
      sendingType: true,
      positionType: false,
      position1: null,
      position2: null,
      list: [],
      value: '',
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 18,
      cursor: null,
    }
  },
  watch: {
    list: function () {
      this.$nextTick(() => {
        this.positioning()
      });
    },
    value: function () {
      if(this.value == ''){
        this.buttomType = false
      }else {
        this.buttomType = true
      }
    }
  },
  methods: {
    onLoad(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.cursor = null
        this.positionType = false
        this.list = [];
      }else {
        this.positionType = true
      }
      this.loading = true
      getPrivateMessageRecord({
        userId: this.id,
        cursor:this.cursor,
        pageSize:15,
      }).then(res => {
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          let freshList = data.list;
          this.list = data.list.concat(this.list)
          this.cursor=data.cursor
          if (data.isLast) {//是否是最后一页
            this.finished = true
          } else {
            this.finished = false
          }
          let unreadIds = freshList.filter(item => !item.isRead && item.senderRole == 'user').map(item => item.id);
          if (unreadIds.length>0){
            setTimeout(() => {
              this.isReads(unreadIds);
            }, 1000);
          }
        } else {
          this.finished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    positioning(){
      if(!this.positionType){
        document.querySelector('.chat-body').scrollTo(0, document.querySelector('.chat-body').scrollHeight - document.querySelector('.chat-body').clientHeight);
        this.position1 = document.querySelector('.list').scrollHeight
      }else {
        this.position2 = document.querySelector('.list').scrollHeight
        document.querySelector('.chat-body').scrollTo(0, this.position2 - this.position1);
        this.position1 = this.position2
      }
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'MM月DD日'
      }
      return moment(date).format(format);
    },
    sending() {
      if(this.value.length > 0){
        if(this.sendingType){
          sendMessage({
            userId: this.id,
            message: this.value
          }).then(res => {
            const data = res.data;
            if (data.code == 0) {
              this.positionType = false
              this.list = this.list.concat(data.privateMessageRecord)
              this.value = ''
              this.sendingType = false
              setTimeout(() => {
                this.sendingType = true
              }, 3000);
            } else {
              Dialog.alert({
                title: '发送失败',
                message: data.msg
              })
            }
          })
        }else {
          Toast('操作过于频繁');
        }
      }else {
        Toast('请输入内容');
      }
    },
    isReads(unreadIds){
      if (unreadIds.length<=0){
        return
      }
      read(this.id,JSON.stringify(unreadIds)).then(res => {
        const data = res.data;
        if (data.code == 0) {
          for (let i = 0; i < unreadIds.length; i++) {
            this.list[this.list.findIndex(obj => obj.id === unreadIds[i])].isRead = true
          }
        } else {
          Dialog.alert({
            title: '已读失败',
            message: data.msg
          })
        }
      })
    },
  },
  mounted() {
    this.onLoad(true)
    bothPersonalInfo({
      userId: this.id
    }).then(res => {
      const data = res.data;
      if (data.code == 0) {
        this.userData = data.user
        document.title = this.userData.nickname
      } else {
        Dialog.alert({
          title: '获取失败',
          message: data.msg
        })
      }
    })
  }
}
</script>

<style lang="less" scoped>
.body{
  width: 100vw;
  height: 100vh;
  background: #F2F3F5;
  .chat-body{
    height: calc(100% - 60px);
    width: 100vw;
    overflow-y: auto;
    .list{
      .my-box{
        padding-bottom: 20px;
        .date{
          text-align: center;
          padding: 10px 0 13px 0;
          color: #B1B1B2;
          font-size: 11px;
          font-weight: 500;
        }
        .my{
          display: flex;
          align-items: center;
          justify-content: right;
          .bubble{
            font-size: 13px;
            font-weight: 500;
            color: #fff;
            line-height: 20px;
            background: #379FFF;
            padding: 10px 12px;
            max-width: 60vw;
            margin-right: 23px;
            border-radius: 20px 20px 5px 20px;
          }
        }
      }
      .you-box{
        padding-bottom: 20px;
        .date{
          text-align: center;
          padding: 10px 0 7px 0;
          color: #B1B1B2;
          font-size: 11px;
          font-weight: 500;
        }
        .you{
          display: flex;
          .head{
            width: 35px;
            height: 35px;
            border-radius: 50%;
            overflow: hidden;
            margin: 0 11px 0 22px;
            background: #FDCC43;
            img{
              width: 100%;
              height: 100%;
              display: block;
            }
          }
          .bubble-box{
            display: flex;
            align-items: center;
            margin-top: 6px;
            .bubble{
              font-size: 13px;
              font-weight: 500;
              color: #333;
              line-height: 20px;
              background: #fff;
              padding: 10px 12px;
              max-width: 60vw;
              border-radius: 5px 20px 20px 20px;
            }
            .state{
              color: #B1B1B2;
              font-size: 11px;
              font-weight: 500;
              margin-left: 7px;
            }
          }
        }
      }
    }
  }
  .input-box{
    width: calc(100vw - 16px * 2);
    display: flex;
    align-items: center;
    padding: 12px 16px;
    position: absolute;
    left: 0;
    bottom: 0;
    background: #fff;
    .van-cell{
      background: #F2F3F5;
      border-radius: 999px;
      padding: 6px 16px;
    }
    .sending{
      height: 36px;
      padding: 0 19px;
      border-radius: 999px;
      display: flex;
      align-items: center;
      background: #379FFF;
      white-space: nowrap;
      color: #fff;
      font-size: 13px;
      font-weight: bold;
      margin-left: 16px;
    }
    .sendingNo{
      background: #73b9ff;
    }
  }
}
</style>
